// Guard against external scripts (browser extensions, Google Translate, injected ads)
// that mutate the DOM outside React and cause "NotFoundError: removeChild/insertBefore"
// crashes (white screen) during route changes. Canonical workaround from facebook/react#11538.
// Note: no ad integration remains in this app — this is purely defensive.
export function patchDomForExternalScripts() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      console.warn("[dom-guard] skipped removeChild of a node already moved by an external script");
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn("[dom-guard] skipped insertBefore with a reference node moved by an external script");
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
